if($('body').hasClass('template--collection')){
  console.log('test');
  // INFINITE COLLECTION
  var pInfScrLoading = false;
  var pInfScrDelay = 100;
  
  function pInfScrExecute() {
    if( $('product-list').height() - 400 < $(document).scrollTop()) {
      var loadingImage;
      var pInfScrNode = $('product-list').find('.more');	        
      // removeing this condition && pInfScrNode.css('display') != 'none'
      if(!pInfScrLoading && pInfScrNode.length > 0) {
        var pInfScrURL = $('product-list').find('.more a').attr("href");
        $('.product-list').append('<img src="https://cdn.shopify.com/s/files/1/0677/8830/8678/files/Rolling_1x-1.0s-200px-200px.gif?v=1747490794" class="loading" />');
        $.ajax({
          type: 'GET',
          url: pInfScrURL,
          beforeSend: function() {
            pInfScrLoading = true;
            loadingImage = pInfScrNode.clone().empty().append('');
            loadingImage.insertAfter(pInfScrNode);
            pInfScrNode.hide();
            
            console.log('loading...');
          },
          success: function(data) {
            // remove loading feedback
            // pInfScrNode.next().remove();
            $('.product-list').find('.more,.loading').remove();
            var filteredData = $(data).find(".product-list");
            // filteredData.attr('data-gridview',$('.grid_view_selector .view_wp.active').attr('data-gridview'));
            $('.product-list').append(filteredData.html());
            
            // if(filteredData.find('.more').length > 0){
            //   $('.product-list__inner.grid_view_custom').find('.more').html(filteredData.find('.more').html());
            // }else{
            //   $('.product-list__inner.grid_view_custom').find('.more').remove();
            // }
            
            
            loadingImage.remove();	              
            $('.product-list').find('.loading').remove();
            pInfScrLoading = false;
            // document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
            try {
              if(typeof iWish!=='undefined'){ iWish.checkIwishColl();}
            } catch (error) {
              // console.log(error);
            }
          },
          dataType: "html"
        });
      }
    }
  }
  $(document).ready(function () {
    $(window).scroll(function(){
      $.doTimeout( 'scroll', pInfScrDelay, pInfScrExecute);
      // if( $(document).height() - 800 > $(document).scrollTop() + $(window).height() ) {
      if( $('.product-list').height() - 400 < $(document).scrollTop()) {
        pInfScrDelay = 20;
      }
    });
  });
}

$(document).ready(function() {  
  $('.collection-list_secondary-main_wrapper').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 699,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      }
    ]
  });

  $('.product-card__slider').each(function(index, element) {
    const $slider = $(element);
  
    // Bind slider events for this specific slider
    $slider.on('init', function(event, slick){
      console.log('slider initialized');
      updateVisibleDots($slider, slick.currentSlide);
    });
  
    $slider.on('afterChange', function(event, slick, currentSlide){
      updateVisibleDots($slider, currentSlide);
    });
  
    // Initialize slick for this slider
    $slider.slick({
      arrows: false,
      dots: true,
      slidesToShow: 1,
      autoplay: false,
      speed: 900,
      autoplaySpeed: 700
    });
  });
  
  // Pass the correct slider to this function
  function updateVisibleDots($slider, currentIndex) {
    const $dots = $slider.find('.slick-dots li');
    $dots.removeClass('visible-dot');
    $dots.each(function(index) {
      if(currentIndex == 0){
        if (index === currentIndex || index === currentIndex + 1 || index === currentIndex + 2) {
          $(this).addClass('visible-dot');
        }
      } else if(currentIndex == ($dots.length - 1)){
        if (index === currentIndex || index === currentIndex - 1 || index === currentIndex - 2) {
          $(this).addClass('visible-dot');
        }
      } else {
        if (index === currentIndex || index === currentIndex - 1 || index === currentIndex + 1) {
          $(this).addClass('visible-dot');
        }
      }
    });
  }


  if ($(window).width() < 1000) {
    $('.category-with-menu_page-title').click(function () {
      $(this).toggleClass('active');
      $(this).next().slideToggle();
    });
  }
  if ($(window).width() < 700) {
    $('.footer__block--title').click(function(){
      $(this).toggleClass('active');
      $(this).next('.footer__block--content').slideToggle();
    })
  }
  document.addEventListener('variant:change', function(event) {
    let variant = event.detail.variant; // Gives you access to the whole variant details
    let form = event.target;  
    console.log(variant);
     if (typeof iWish !== 'undefined') {
        iWish.init()
   }
    var product_handle = $("body").attr("product-handle");
    $.get(`/products/${product_handle}?variant=${variant.id}`, function (data) {
      $(".product-meta_variant-specifications")?.html(
        $(data).find(".product-meta_variant-specifications").html()
      );
    });
  });
  document.querySelectorAll('.header-sidebar__linklist li').forEach(function(li) {
  if (li.textContent.toUpperCase().includes('SALE')) {
    li.style.display = 'none';
  }
});

});
